import React, { Component } from 'react';

// Components
import Modal from '../../../../../../../components/Modal';
import Button from '../../../../../../../components/Button';

// css
import './styles.css';

export default class CancelScheduleModal extends Component {
  render() {
    return (
      <Modal
        title="Agendamento 123232"
        size="small"
        onBackdropClick={this.props.closeModal}
      >
        {
          this.props.hasError &&
          <p className="CancelScheduleModal__error-msg">Ocorreu um erro. Tente novamente. {this.props.hasError}</p>
        }
        Deseja cancelar este agendamento?

        <div className="CancelScheduleModal__footer">
          <Button
            skin="gray-light"
            text="Voltar"
            onClick={this.props.closeModal}
          />

          {
            !this.props.isFetching &&
            <Button
              className="CancelScheduleModal__footer-cancel-btn"
              skin="danger"
              text="Cancelar Agendamento"
              onClick={this.props.onScheduleCancel}
            />
          }

          {
            this.props.isFetching &&
            <Button
              disabled
              className="CancelScheduleModal__footer-cancel-btn"
              skin="danger"
              text="Carregando..."
              onClick={this.props.onScheduleCancel}
            />
          }
        </div>
      </Modal>
    );
  }
}
